<template>
  <div>
    <CCard>
      <CCardBody>
        <div>
          <router-link to="/add-user" tag="button" class="btn btn-outline-primary mr-1">
            Add new user
          </router-link>
          <a href="javascript:void(0)"
             class="btn btn-outline-primary mr-2"
             @click="() => { modals.batchAddUsers.show = true }">
            Batch users adding
          </a>
        </div>

        <div class="float-right">
          Show roles:
          <CSwitch
            :checked.sync="rolesEnabled"
            v-bind="switcherLabel"
            class="mx-1"
            color="dark"
            variant="outline"
            shape="pill"
            size="sm"
          />
        </div>
      </CCardBody>
      <TheTable
        :items="usersFormatted"
        :fields="fields"
        :classToSet="'d-none d-sm-block'"
        :loading="loadingDelete"
        :pagination="false"
        :itemsPerPage="pageSize"
        :active-page="currentPage"
        :displayRoleColumn="rolesEnabled"
        @deleteItem="deleteAlert($event)"
        @userClicked="editUser($event)"
        @userDetailsClicked="showUser($event)"
      ></TheTable>
      <TheTable
        :items="usersFormatted"
        :fields="mobileField"
        :classToSet="'d-block d-sm-none'"
        :loading="loadingDelete"
        :itemsPerPage="pageSize"
        :pagination="false"
        :active-page="currentPage"
        @deleteItem="deleteAlert($event)"
        @userClicked="editUser($event)"
        @userDetailsClicked="showUser($event)"
      ></TheTable>
      <CPagination
        v-show="totalPages > 1"
        :activePage.sync="currentPage"
        :pages="totalPages"
      />
      <TheModal
        :color="'warning'"
        :size="'sm'"
        :title="'Delete User'"
        :showModal="deleteModal"
        :text="`Are you sure you want to delete <b>${userToDelete.name}</b>.`"
        @cancel="cancel($event)"
        @okay="deleteUser($event)"
      />
    </CCard>
    <CToaster :autohide="3000" v-if="error.showError">
      <template>
        <CToast :show="true" header="Information Popup">
          {{ error.text }}
        </CToast>
      </template>
    </CToaster>

    <!-- modals section -->
    <!-- batch users modal -->
    <batch-users-add-modal :show.sync="modals.batchAddUsers.show" />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import TheTable from "./../containers/TheTable";
import TheModal from "./../containers/TheModal";
import BatchUsersAddModal from "@/components/organization/modals/BatchUsersAddModal";

export default {
  name: "profile",
  components: {
    BatchUsersAddModal,
    TheTable,
    TheModal,
  },
  data() {
    return {
      fields: [
        {
          key: "name",
        },
        {
          key: "email",
        },
        {
          key: "organization",
        },
        {
          key: "last_login",
        },
        {
          key: "logins_count",
          label: "Login Count",
          _style: "width:1%",
        },
        {
          label: "Provider",
          key: "provider",
        },
        {
          label: "User Status",
          key: "userstatus",
          _style: "width:1%",
        },
        {
          label: "Roles",
          key: "roles",
        },
        {
          key: "show",
          label: "Action",
          _style: "width:1%",
          sorter: false,
          filter: false,
        },
        {
          key: "editUser",
          label: "Action",
          _style: "width:1%",
          sorter: false,
          filter: false,
        },
        {
          key: "delete",
          label: "Action",
          sorter: false,
          _style: "width:1%",
          filter: false,
        },
      ],
      mobileField: [
        {
          key: "name",
          _style: "width:40%",
        },
        {
          key: "email",
        },
        {
          key: "last_login",
        },
        {
          label: "User Status",
          key: "userstatus",
        },
        {
          label: "Trial Expiry",
          key: "trialexpiry",
        },
        {
          key: "edit",
          label: "Action",
          _style: "width:1%",
          sorter: false,
          filter: false,
        },

        {
          key: "delete",
          label: "Action",
          sorter: false,
          _style: "width:1%",
          filter: false,
        },
      ],
      auth: {
        apiToken: null,
        user: {},
        access_token: null,
      },
      pageSize: 50,
      currentPage: 1,
      apiPageSize: 50,
      userResult: {
        users: [],
        total: 0,
        limit: 0,
        pagesFetched: 0,
      },
      roleUsers: {},
      roles: [],
      deleteModal: false,
      userToDelete: {},
      error: {
        showError: false,
        text: "",
      },
      loadingDelete: [],
      responsive: true,
      rolesEnabled: true,

      switcherLabel: {
        labelOn: "yes",
        labelOff: "no",
      },

      modals: {
        batchAddUsers: { show: false },
      },
    };
  },
  async mounted() {
    await this.getUserData(false);
    const roles = await this.getRolesOnBoot();
  },
  methods: {
    ...mapActions([
      "listUsers",
      "deleteUserFunction",
      "getRoles",
      "getRoleUsers",
    ]),
    login() {
      // this.$auth.loginWithRedirect();
    },
    async getUserData(append) {
      if (append) {
        let data = await this.listUsers({
          include_totals: true,
          per_page: this.apiPageSize,
          page: this.userResult.pagesFetched,
        });
        this.userResult.users = this.userResult.users.concat(data.users);
      } else {
        let data = await this.listUsers({
          include_totals: true,
          per_page: this.apiPageSize,
        });
        this.userResult.total = data.total;
        this.userResult.limit = data.limit;

        this.userResult.users = data.users;
      }
    },

    async getRolesOnBoot() {
      let roles = await this.getRoles();

      const promises = roles.map(async (role) => {
        const roleData = await this.getRoleUsersOnBoot(role.id, role.name);
        return roleData;
      });

      const roleStructs = await Promise.all(promises);

      const userLists = roleStructs.map((role) => this.transformUserlist(role));
      this.roles = this.consolidateRoles(userLists);
    },

    async getRoleUsersOnBoot(id, name) {
      let roleData = await this.getRoleUsers({
        id: id,
        params: { per_page: 100 },
      });
      roleData = roleData.data.map((role) => role.email);
      return { id: id, name: name, users: roleData };
    },

    deleteAlert(el) {
      this.deleteModal = !this.deleteModal;
      if (this.deleteModal)
        (this.userToDelete = el.item), (this.userToDelete["index"] = el.index);
      else this.userToDelete = {};
    },

    consolidateRoles(roles) {
      const userList = {
        "msc@oceanbolt.com": ["The Boss"],
        "ndp@oceanbolt.com": ["The Apprentice"],
      };
      roles.map((role) => {
        Object.keys(role).map((email) => {
          if (userList[email]) {
            if (email === "msc@oceanbolt.com") {
            }
            userList[email].push(role[email]);
          } else {
            userList[email] = [role[email]];
          }
        });
      });
      return userList;
    },

    transformUserlist(roleStruct) {
      const output = {};
      roleStruct.users.forEach((user) => (output[user] = roleStruct.name));

      const mappedUsers = roleStruct.users.map((user) => {
        const struct = {};
        struct.email = user;
        struct.role = roleStruct.name;
        return struct;
      });

      return output;
    },

    async deleteUser() {
      this.deleteModal = false;
      this.$set(this.loadingDelete, this.userToDelete.index, true);
      this.$forceUpdate();
      let response = await this.deleteUserFunction(this.userToDelete.user_id);
      if (!response.error) {
        this.error.text = "User successfully deleted.";
        this.getUserData();
      } else {
        this.error.text = response.error_details.message;
      }
      this.error.showError = true;
      this.$set(this.loadingDelete, this.userToDelete.index, false);
      this.$forceUpdate();
      this.userToDelete = {};
    },
    cancel() {
      this.userToDelete = {};
      this.deleteModal = false;
    },
    editUser(user) {
      this.$router.push({ name: "Edit User", params: { user: user } });
    },
    showUser(id) {
      this.$router.push({ path: "user-details/" + id });
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.userResult.total / this.pageSize) || 1;
    },
    usersFormatted() {
      return this.userResult.users.map((user) => {
        if (this.roles[user.email]) {
          user.roles = this.roles[user.email].sort();
        } else {
          user.roles = ["No roles"];
        }

        return user;
      });
    },
  },
  watch: {
    currentPage: async function(value) {
      if (value >= this.userResult.pagesFetched) {
        this.userResult.pagesFetched += 1;
        await this.getUserData(true);
      }
    },
  },
};
</script>

<style>
.picture-container {
  display: flex;
  justify-content: right;
  align-items: flex-end;
  float: right;
}

.profile-pic {
  display: block;
  max-width: 400px;
  max-height: 400px;
  width: auto;
  height: auto;
  border-radius: 50%;
}
</style>
